
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/kondomer",
      function () {
        return require("private-next-pages/sexleketoy/kondomer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/kondomer"])
      });
    }
  